import React, { useState, useEffect } from 'react';
import Modal from '../../../../components/shareable/modal';
import toast from 'react-hot-toast';
import { Eye, EyeOff } from 'lucide-react';

const ResetPasswordModal = ({ isOpen, onClose, onConfirm, userEmail }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');

  useEffect(() => { if (isOpen) { setPassword(''); } }, [isOpen]);

  const inputType = showPassword ? 'text' : 'password';

  const handleConfirm = () => {
    if (password.trim().length < 6) {
      toast.error('Password must be at least 6 characters.');
      return;
    }
    onConfirm(password);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        {/* Header */}
        <div className="flex items-center justify-center mb-6">
          <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Reset Password</h2>
        <p className="text-center text-gray-600 mb-6">Set a new password for this user</p>

        {/* User Info Card */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200">
          <p className="text-sm text-gray-600 mb-1">User Account</p>
          <p className="font-medium text-gray-800 truncate">{userEmail || 'N/A'}</p>
        </div>
        
        {/* Password Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            New Password
          </label>
          <div className="relative">
            <input type={inputType} className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition duration-200" placeholder="Enter new password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            <button type="button" onClick={() => setShowPassword((prev) => !prev)} className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-red-600 transition-colors duration-200" >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
          <p className="mt-2 text-xs text-gray-500">Password must be at least 6 characters</p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row sm:justify-end gap-3 mt-8">
          <button className="px-5 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" onClick={onClose} >
            Cancel
          </button>
          <button className="px-5 py-3 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" onClick={handleConfirm} >
            Reset Password
          </button>
        </div>
    </Modal>
  );
};

export default ResetPasswordModal;
